// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Nephron sub-tooltip — ported from the Claude Design "Combat Hover Grammar"
   kidney panel and augmented from 3 to 5 segments (NephronDiagram.jsx). The
   regions share the diuresis-teal identity, split into a 5-step tint ramp so each
   segment reads apart: lightest at the top of the nephron (proximal), darkest at
   the collecting duct — keeping the design's original loop/distal/collecting order
   of increasing depth. Ion arrows follow the design: DOWN in band-red, UP in the
   diuresis teal. Inactive segments (no equipped diuretic) dim + hollow the dot and
   dash their tubule limb, identical to the design's partial-blockade variants. */
.gt-kidney {
  --seg-pct: rgb(153, 246, 228);  /* proximal (top, lightest) */
  --seg-osm: rgb(94, 234, 212);   /* descending limb */
  --seg-loop: rgb(45, 212, 191);  /* loop of Henle */
  --seg-thz: rgb(20, 184, 166);   /* distal tubule */
  --seg-ksp: rgb(13, 148, 136);   /* collecting duct (bottom, darkest) */
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 6px 0 2px;
}
.gt-kidney__fig {
  flex: 0 0 92px;
  width: 92px;
}
.gt-kidney__fig svg {
  width: 100%;
  height: auto;
  display: block;
}
.gt-kidney__legend {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  flex: 1 1;
}
.gt-kidney__seg {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  line-height: 1.3;
}
.gt-kidney__dot {
  flex: 0 0 7px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-top: 6px;
}
.gt-kidney__txt {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}
.gt-kidney__region {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--text-secondary, #e5e7eb);
  white-space: nowrap;
}
.gt-kidney__drug {
  font-size: 0.6rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  color: var(--text-muted, #9ca3af);
  white-space: nowrap;
}
.gt-kidney__eff {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 3px 7px;
  margin-top: 1px;
}
.gt-kidney__ion {
  display: inline-flex;
  align-items: center;
  gap: 0;
  font-size: 0.64rem;
  font-weight: 800;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.gt-kidney__ion svg {
  width: 11px;
  height: 11px;
  display: block;
}
.gt-kidney__ion--down { color: var(--band-red, rgb(248, 113, 113)); }
.gt-kidney__ion--up { color: var(--diuresis, rgb(45, 212, 191)); }
.gt-kidney__eff--off {
  font-size: 0.6rem;
  font-weight: 600;
  font-style: italic;
  letter-spacing: 0.03em;
  color: var(--text-muted, #9ca3af);
}
/* Inactive region: no drug occupies that segment this round — dim the legend row,
   hollow its dot, and (in the figure) render the tubule limb as a muted dashed
   path. Same element, fewer active sites. */
.gt-kidney__seg--off { opacity: 0.4; }
.gt-kidney__seg--off .gt-kidney__dot {
  background: transparent !important;
  box-shadow: inset 0 0 0 1.5px rgba(148, 163, 184, 0.7);
}
.gt-kidney__seg--off .gt-kidney__drug { font-style: italic; }
.gt-kidney__path--off {
  stroke: rgba(148, 163, 184, 0.32) !important;
  stroke-dasharray: 2.5 4;
}
`, "",{"version":3,"sources":["webpack://./src/components/CombatPlayerbar/NephronDiagram.css"],"names":[],"mappings":"AAAA;;;;;;;iFAOiF;AACjF;EACE,6BAA6B,GAAG,6BAA6B;EAC7D,4BAA4B,IAAI,oBAAoB;EACpD,6BAA6B,GAAG,kBAAkB;EAClD,4BAA4B,IAAI,kBAAkB;EAClD,4BAA4B,IAAI,sCAAsC;EACtE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,MAAM;EACN,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA,wBAAwB,0CAA0C,EAAE;AACpE,sBAAsB,yCAAyC,EAAE;AACjE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,iCAAiC;AACnC;AACA;;4CAE4C;AAC5C,uBAAuB,YAAY,EAAE;AACrC;EACE,kCAAkC;EAClC,sDAAsD;AACxD;AACA,wCAAwC,kBAAkB,EAAE;AAC5D;EACE,4CAA4C;EAC5C,uBAAuB;AACzB","sourcesContent":["/* Nephron sub-tooltip — ported from the Claude Design \"Combat Hover Grammar\"\n   kidney panel and augmented from 3 to 5 segments (NephronDiagram.jsx). The\n   regions share the diuresis-teal identity, split into a 5-step tint ramp so each\n   segment reads apart: lightest at the top of the nephron (proximal), darkest at\n   the collecting duct — keeping the design's original loop/distal/collecting order\n   of increasing depth. Ion arrows follow the design: DOWN in band-red, UP in the\n   diuresis teal. Inactive segments (no equipped diuretic) dim + hollow the dot and\n   dash their tubule limb, identical to the design's partial-blockade variants. */\n.gt-kidney {\n  --seg-pct: rgb(153, 246, 228);  /* proximal (top, lightest) */\n  --seg-osm: rgb(94, 234, 212);   /* descending limb */\n  --seg-loop: rgb(45, 212, 191);  /* loop of Henle */\n  --seg-thz: rgb(20, 184, 166);   /* distal tubule */\n  --seg-ksp: rgb(13, 148, 136);   /* collecting duct (bottom, darkest) */\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 6px 0 2px;\n}\n.gt-kidney__fig {\n  flex: 0 0 92px;\n  width: 92px;\n}\n.gt-kidney__fig svg {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n.gt-kidney__legend {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n  flex: 1 1 0;\n}\n.gt-kidney__seg {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  line-height: 1.3;\n}\n.gt-kidney__dot {\n  flex: 0 0 7px;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  margin-top: 6px;\n}\n.gt-kidney__txt {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-width: 0;\n}\n.gt-kidney__region {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: var(--text-secondary, #e5e7eb);\n  white-space: nowrap;\n}\n.gt-kidney__drug {\n  font-size: 0.6rem;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  color: var(--text-muted, #9ca3af);\n  white-space: nowrap;\n}\n.gt-kidney__eff {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 3px 7px;\n  margin-top: 1px;\n}\n.gt-kidney__ion {\n  display: inline-flex;\n  align-items: center;\n  gap: 0;\n  font-size: 0.64rem;\n  font-weight: 800;\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n.gt-kidney__ion svg {\n  width: 11px;\n  height: 11px;\n  display: block;\n}\n.gt-kidney__ion--down { color: var(--band-red, rgb(248, 113, 113)); }\n.gt-kidney__ion--up { color: var(--diuresis, rgb(45, 212, 191)); }\n.gt-kidney__eff--off {\n  font-size: 0.6rem;\n  font-weight: 600;\n  font-style: italic;\n  letter-spacing: 0.03em;\n  color: var(--text-muted, #9ca3af);\n}\n/* Inactive region: no drug occupies that segment this round — dim the legend row,\n   hollow its dot, and (in the figure) render the tubule limb as a muted dashed\n   path. Same element, fewer active sites. */\n.gt-kidney__seg--off { opacity: 0.4; }\n.gt-kidney__seg--off .gt-kidney__dot {\n  background: transparent !important;\n  box-shadow: inset 0 0 0 1.5px rgba(148, 163, 184, 0.7);\n}\n.gt-kidney__seg--off .gt-kidney__drug { font-style: italic; }\n.gt-kidney__path--off {\n  stroke: rgba(148, 163, 184, 0.32) !important;\n  stroke-dasharray: 2.5 4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
